import React, { useState, useRef, useEffect } from 'react';
import './FAQ.css';
import { FaAngleDown } from 'react-icons/fa';

const FAQ = () => {
    const faqs = [
        {
            question: "When was JDS Hospitals, Visakhapatnam established?",
            answer: "JDS Hospitals, Visakhapatnam was established in [Year]. It has been serving the community with quality healthcare services ever since."
        },
        {
            question: "Why is JDS Hospitals, Ramnagar considered the best hospital in Visakhapatnam?",
            answer: "JDS Hospitals, Ramnagar is considered the best due to its state-of-the-art facilities, experienced medical professionals, and commitment to patient care."
        },
        {
            question: "Why should you choose JDS Hospitals, Visakhapatnam?",
            answer: "You should choose JDS Hospitals for its comprehensive medical services, advanced technology, and patient-centered approach to healthcare."
        },
        {
            question: "What are the hours of operation of JDS Hospitals, Ramnagar, Visakhapatnam?",
            answer: "JDS Hospitals operates 24/7 to provide round-the-clock emergency and medical services."
        },
        {
            question: "How to Book an Online Consultation at JDS Hospitals, Ramnagar, Visakhapatnam?",
            answer: "You can book an online consultation through our website or by calling our helpline. Visit the appointments section for more details."
        },
        {
            question: "How many beds are there in JDS Hospitals, Ramnagar, Visakhapatnam?",
            answer: "JDS Hospitals has [Number] beds to accommodate patients and provide comprehensive care."
        },
        {
            question: "Does JDS Hospitals, Ramnagar, Visakhapatnam have a cafeteria?",
            answer: "Yes, JDS Hospitals provides a cafeteria for patients, visitors, and staff with a variety of nutritious meals."
        }
    ];

    // tracks which items are open (true/false)
    const [open, setOpen] = useState({});

    // refs for each answer block to measure height
    const contentRefs = useRef([]);

    // ensure refs array length matches faqs length
    useEffect(() => {
        contentRefs.current = contentRefs.current.slice(0, faqs.length);
    }, [faqs.length]);

    const toggleFAQ = (index) => {
        // toggle open/close for this index
        setOpen(prev => ({ ...prev, [index]: !prev[index] }));
    };

    return (
        <section className="faq-section">
            <div className="container">
                <h2 className="faq-title">Frequently Asked Questions</h2>
                <div className="faq-list">
                    {faqs.map((faq, index) => {
                        const isOpen = !!open[index];
                        // measure scrollHeight to animate max-height
                        const contentEl = contentRefs.current[index];
                        const maxHeight = contentEl && isOpen ? `${contentEl.scrollHeight}px` : '0px';

                        return (
                            <div key={index} className={`faq-item ${isOpen ? 'open' : ''}`}>
                                <div className="faq-question" onClick={() => toggleFAQ(index)}>
                                    <span>{faq.question}</span>
                                    <FaAngleDown className={`faq-icon ${isOpen ? 'rotated' : ''}`} />
                                </div>

                                <div
                                    ref={el => contentRefs.current[index] = el}
                                    className="faq-answer"
                                    style={{ maxHeight }}
                                    aria-hidden={!isOpen}
                                >
                                    <div className="faq-answer-inner">
                                        <p>{faq.answer}</p>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};

export default FAQ;
